import * as React from "react";
import { styled, alpha } from "@mui/material";
import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",

    "& div": {
      minWidth: theme.spacing(5),
      maxWidth: theme.spacing(5),
      minHeight: theme.spacing(5),
      maxHeight: theme.spacing(5),
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  },
  input: {
    display: "inline-block",
    width: "70%",
    paddding: "20",
    margin: "0",
  },

  error: {},

  IconContainerBgPaperBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    margin: `auto ${theme.spacing(20)}`,
  },
  IconContainerBgPaper: {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
    // width: theme.spacing(5),
    // height: theme.spacing(5),
    minWidth: theme.spacing(5),
    maxWidth: theme.spacing(5),
    minHeight: theme.spacing(5),
    maxHeight: theme.spacing(5),
    textAlign: "center",
    padding: theme.spacing(1),
    margin: `auto ${theme.spacing(2)}`,
  },

  formLabel: {
    fontSize: theme.spacing(2),
    color: theme.palette.text.main,
    display: "block",
    width: theme.spacing(80),
    marginTop: theme.spacing(2),
  },

  forgotPasswordTextBtn: {
    display: "inline-block",
    padding: 0,
    minHeight: 0,
    minWidth: 0,
  },
  signInBtn: {
    minWidth: "100%",
    marginBottom: theme.spacing(3),
  },

  bottomTextBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    margin: theme.spacing(4),

    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(4, 1),
    },
  },

  createAccountBtn: {
    // color: theme.palette.text.main,
    display: "inline-block",
    padding: 0,
    minHeight: 0,
    minWidth: 0,
  },

  signInText: {
    display: "flex",
    marginBottom: theme.spacing(3),
    color: theme.palette.text.main,
    justifyContent: "center",
  },
}));
